<app-header [tiny]="true">
  <a
    appButton
    name="DONTREPORT"
    location="asset-header"
    [iconButton]="true"
    color="simple-gray"
    height="1"
    (click)="close()"
    class="back"
    *ngIf="!embedMode"
    [appTooltip]="'back-to-gallery' | translate"
    tooltipKeyboardShortcut="ESC"
    toolTipOrigin="right"
  >
    <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
  </a>
  <app-asset-page-meta
    [asset]="asset"
    [thumbnailBarOpen]="thumbnailBarOpen"
    [gallery]="gallery"
    [accessLevel]="accessLevel"
    [activeIndex]="activeIndex"
    (onThumbnailBarOpen)="onThumbnailBarOpen.emit($event)"
  >
  </app-asset-page-meta>

  <div class="spacer"></div>

  <div class="right-buttons">
    <ng-container *ngIf="clientMode">
      <app-context-menu
        [options]="{ width: '320px', noSpacing: true }"
        name="view-gallery context"
        #menu
        *ngIf="state.user || state.guest?.email"
      >
        <div
          class="profile-circle"
          appTooltip="Your Profile"
          [class.auto-border]="state.user?.avatar_url"
          [style.--avatar-border-color]="state.user || state.guest | userColor : true | async"
          contextButton
        >
          <img *ngIf="state.user || state.guest | avatar | async as avatarSrc" [src]="avatarSrc" alt="" />
        </div>
        <app-view-profile-menu
          [accessLevel]="accessLevel"
          [gallery]="gallery"
          contextContent
          (onClose)="menu.close()"
        ></app-view-profile-menu>
      </app-context-menu>

      <div
        class="profile-circle"
        appTooltip="Your Profile"
        [class.auto-border]="state.user?.avatar_url"
        [style.--avatar-border-color]="state.user || state.guest | userColor : true | async"
        (click)="openGuestProfileDialog()"
        *ngIf="!state.user && !state.guest?.email && accessLevel !== 'view_only'"
      >
        <img *ngIf="state.guest | avatar | async as avatarSrc" [src]="avatarSrc" alt="" />
      </div>
    </ng-container>
    <app-context-menu
      class="guest-info"
      [options]="{ width: '233px' }"
      verticalPosition="bottom"
      position="center"
      #anonymousGuestInfo
    >
      <div contextContent (click)="anonymousGuestInfo.close(); openGuestProfileDialog()" class="guest-info-content">
        You left feedback anonymously. Click here to add your info and let others know who you are.
      </div>
    </app-context-menu>

    <button
      appButton
      name="share"
      location="asset-header"
      [iconButton]="true"
      height="1"
      color="simple-gray"
      (click)="openShareDialog()"
      [appTooltip]="'share-cta' | translate"
      *ngIf="!clientMode"
    >
      <app-svg src="/assets/icons/forward.svg"></app-svg>
    </button>

    <ng-container *ngIf="gallery.download_single_asset">
      <app-context-menu
        [options]="{ width: '240px', noSpacing: true }"
        #menu
        [position]="'right'"
        *ngIf="!iosDownloadMenu"
      >
        <button
          appButton
          name="download"
          location="asset-header"
          [iconButton]="true"
          color="simple-gray"
          height="1"
          [appTooltip]="'download-button' | translate"
          contextButton
        >
          <app-svg src="/assets/icons/download.svg"></app-svg>
        </button>
        <app-download-size-selection
          [accessLevel]="accessLevel"
          [asset]="asset"
          [gallery]="gallery"
          (onSelect)="download($event); menu.close()"
          contextContent
        >
        </app-download-size-selection>
      </app-context-menu>

      <app-ios-download-context
        [asset]="asset"
        [accessLevel]="accessLevel"
        [gallery]="gallery"
        [previewWidth]="previewWidth"
        (download)="download($event)"
        *ngIf="iosDownloadMenu"
      >
      </app-ios-download-context>
    </ng-container>

    <button
      appButton
      name="info"
      location="asset-header"
      [iconButton]="true"
      height="1"
      color="simple-gray"
      (click)="onShowInfo.emit()"
      [appTooltip]="'asset-information' | translate"
      [toolTipOrigin]="'left'"
      [tooltipKeyboardShortcut]="'I'"
    >
      <app-svg src="/assets/icons/info-outline.svg"></app-svg>
    </button>
  </div>
</app-header>
